import { ChangePasswordMessages, TranslationChangePasswordMessages } from "@languages/interfaces";

export const messages: TranslationChangePasswordMessages = {
  [ChangePasswordMessages.currentPasswordInstruction]: "Ingrese su contraseña actual de Topcon Customer",
  [ChangePasswordMessages.currentPasswordLabel]: "Contraseña actual",
  [ChangePasswordMessages.newPasswordInstruction]: "Ingrese su nueva contraseña",
  [ChangePasswordMessages.newPasswordLabel]: "Nueva contraseña",
  [ChangePasswordMessages.confirmPasswordInstruction]: "Confirme su nueva contraseña",
  [ChangePasswordMessages.currentPasswordRequired]: "La contraseña actual es obligatoria",
  [ChangePasswordMessages.newPasswordRequired]: "La nueva contraseña es obligatoria",
  [ChangePasswordMessages.confirmPasswordRequired]: "La confirmación de contraseña es obligatoria",
  [ChangePasswordMessages.newPasswordMinimumLength]: "La nueva contraseña debe tener al menos 6 caracteres",
  [ChangePasswordMessages.confirmPasswordNotMatch]: "Las contraseñas no coinciden",
  [ChangePasswordMessages.changePasswordSuccess]: "Contraseña cambiada con éxito",
  [ChangePasswordMessages.changePasswordFailed]: "Error al cambiar la contraseña",
  [ChangePasswordMessages.changePasswordButtonTitle]: "Cambiar contraseña"
};